import React from 'react';
import Hero from "./components/self-course/Hero";
import Main from "./components/self-course/Main";

const SelfFinanceCourse = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default SelfFinanceCourse;